import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";

import Notifications from "unicorn-notifications";
import "@mdi/font/css/materialdesignicons.css";

Vue.use(Notifications);

Vue.config.productionTip = false;

export const app = new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
